import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Numbers from "../../components/StatsCard";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/BreadcrumbTitle";
import Chart1 from "components/Chart1";
import Chart2 from "components/Chart2";
import { decryptedValue, isPermission } from "common/utility";
import { getUserDashboardWidget } from "http/UAM/userDashboardWidget.helper";
import { Link } from "react-router-dom";

const CustomerDashboard = (props) => {
  document.title = "Dashboard | FundLync";
  const [isAdminStatsPermission, setAdminStatsPermission] = useState(false)
  const [isDealStatusPermission, setDealStatusPermission] = useState(false)
  const [isSixMonthStatusPermission, setSixMonthStatus] = useState(false)
  let userDetails = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    getUserDashboardWidget({ userId: userDetails.id })
      .then((response) => {
        if (response.status) {
          checkUserDashboardWidgets(response.data?.rows[0]?.dashboardWidgets)
        } else {
          checkPermissions()
        }
      })
      .catch((error) => {
        console.log(error)
      })

  }, [])

  const checkUserDashboardWidgets = (userDashboardWidgetList) => {
    const isAdminStat = userDashboardWidgetList.CIadmin_stats == 1
    const isDealStatus = userDashboardWidgetList.deal_status == 1
    const isSixMonthStatus = userDashboardWidgetList.six_month_throughput == 1
    setAdminStatsPermission(isAdminStat)
    setDealStatusPermission(isDealStatus)
    setSixMonthStatus(isSixMonthStatus)
  }

  const checkPermissions = async () => {

    const isAdminStat = await isPermission("admin_stats", "view_permission")
    const isDealStatus = await isPermission("deal_status", "view_permission")
    const isSixMonthStatus = await isPermission("six_month_throughput", "view_permission")
    setAdminStatsPermission(isAdminStat)
    setDealStatusPermission(isDealStatus)
    setSixMonthStatus(isSixMonthStatus)
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumb */}
        <Breadcrumbs title="DASHBOARDS" />
        <div className="vertical-scroll">
          {isAdminStatsPermission && <Row style={{ marginBottom: "1rem" }} className="row-box">
            {numberData?.map((i) => (
              <Col key={i.id} lg={3}>
                <Numbers label={i?.label} value={i?.value} />
              </Col>
            ))}
          </Row>}
          <Col xl="12"></Col>
          <Row>
            {isSixMonthStatusPermission && <Chart1 dataColors='["--bs-primary"]' />}
            {isDealStatusPermission && <Chart2 dataColors='["--bs-primary", "--bs-success", "--bs-danger","--bs-info"]' />}
          </Row>
          <Row>
            {isAdminStatsPermission || isDealStatusPermission || isSixMonthStatusPermission ||
              <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <Link
                  className={`p-3 fw-bold ${userDetails.roleName === 'admin' ? 'bg-success text-white' : 'bg-primary text-dark'} rounded`}
                  to={`/${userDetails.roleName}/widgetSetting`}
                >
                  + Add Widget
                </Link>
              </div>
            }
          </Row>
        </div>
      </Container>
    </div>
  );
};

const numberData = [
  {
    id: 1,
    label: "No of Entities",
    value: 55,
  },
  {
    id: 2,
    label: "No of Customers",
    value: 125,
  },
  {
    id: 3,
    label: "No of FI onboarded",
    value: 33,
  },
  {
    id: 4,
    label: "My Deals",
    value: 300,
  },
];

export default CustomerDashboard;
